import { render, staticRenderFns } from "./PayItemTypeNew.vue?vue&type=template&id=28aa2378"
import script from "./PayItemTypeNew.vue?vue&type=script&lang=js"
export * from "./PayItemTypeNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports